import { inject } from "aurelia";
import { ModelTypes } from '@zeus';
import { ITemplateService } from '../../services/templates-service';
import { IRouter } from '@aurelia/router';
import { IZeusClient, ZeusClient } from "@services/graphql-service/zeus-client";
import { IDialogService } from "@aurelia/dialog";
import { CreateBrandComponent } from "../../../brand-guide/components/create-brand/create-brand-component";

@inject(IZeusClient, IRouter, ITemplateService, IDialogService)
export class TextTemplatesPage {
  private channel: string = 'texts';

  private brandId: string;
  private currentStep: number;

  constructor(
    private zeusClient: ZeusClient,
    private router: IRouter,
    private service: ITemplateService,
    private dialogService: IDialogService
  ) { }

  async attached() {
    const response = await this.zeusClient.chain('query')({
      brands: [
        { limit: 1 },
        {
          id: true,
          currentStep: true
        }
      ]
    })

    if (response?.brands?.length) {
      this.brandId = response?.brands[0]?.id as string;
      this.currentStep = response?.brands[0]?.currentStep;
    }
  }

  private async getNewTemplateType(channel: string): Promise<ModelTypes['newTemplateType'][]> {
    const result = await this.service.getNewTemplateType(channel);

    const filteredResult = result.filter((item) => item.id !== 'fbb9b8d8-07e8-4fa3-b115-f3c4f69d9816' && item.id !== '8af49843-7de1-4538-8830-f32144a716d0');

    return filteredResult;
  }

  private async handleRedirect(): Promise<void> {

    if ((this.brandId && this.currentStep < 3) || !this.brandId) {
      await this.dialogService.open({
        component: () => CreateBrandComponent,
        model: {
        },
        lock: false,
        startingZIndex: 100,
      });

      return
    } else {
      await this.router.load('/text');
    }

  }
}